import { CopyLinkButton } from '~/components/CopyLinkButton'
import { type ButtonProps } from '~/components/component-library'

export const CopyCurrentUrlButton = ({
  trackingId,
  isDisabled,
  variant,
}: {
  trackingId: string
  isDisabled?: boolean
  variant?: ButtonProps['variant']
}) => {
  return (
    <CopyLinkButton
      link={window.location.href}
      trackingId={trackingId}
      isDisabled={isDisabled}
      variant={variant}
    />
  )
}
